import { NEW_QR_CODES_TEMPLATE_IDS } from '~/constants/common';
import {
  COUPON_QR_ID_PARAM_NAME,
  QR_CODE_BUILDER_CREATED_ID_PARAM_NAME,
  QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME,
  QR_CODE_TYPE,
  QRCODE_DYNAMIC_MICROSITE_TYPE,
  QRCODE_STATIC_STEP,
  QRCODE_STATIC_TYPE,
  VIDEO_QR_ID_PARAM_NAME,
} from '~/constants/qr-code';
import { templates } from '~/constants/queryParams';
import { PATH } from '~/constants/route-path';
import { convertMicrositeTypeToId } from '~/utils/common';

export const getEditQrLink = (qrcode) => {
  const isStaticQr = qrcode.type === QR_CODE_TYPE.STATIC;

  if (isStaticQr) {
    return PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.CONTENT, qrcode.content.type, qrcode.id);
  }

  if (NEW_QR_CODES_TEMPLATE_IDS.includes(qrcode.micrositeType)) {
    let paramName = '';

    if (qrcode.micrositeType === QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON) {
      paramName = COUPON_QR_ID_PARAM_NAME;
    } else if (qrcode.micrositeType === QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO) {
      paramName = VIDEO_QR_ID_PARAM_NAME;
    }

    return `${PATH.QR.CREATE}?template=${qrcode.micrositeType}&${QR_CODE_BUILDER_CREATED_ID_PARAM_NAME}=${qrcode.id}&${QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME}=1&qrCodeId=${qrcode.id}&${paramName}=${qrcode.microsite?.id}`;
  }

  return `${PATH.QR.CREATE}?template=${templates[convertMicrositeTypeToId(qrcode?.micrositeType)]}&${QR_CODE_BUILDER_CREATED_ID_PARAM_NAME}=${qrcode?.id}&${QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME}=1`;
};

export const mapQrTypeForApi = (type) => {
  const mapper = {
    [QRCODE_STATIC_TYPE.URL]: 'url',
    [QRCODE_STATIC_TYPE.WIFI]: 'wifi',
    [QRCODE_STATIC_TYPE.TEXT]: 'text',
    [QRCODE_STATIC_TYPE.EMAIL]: 'email',
    [QRCODE_STATIC_TYPE.SMS]: 'sms',
    [QRCODE_STATIC_TYPE.VCARD]: 'vcard',
    [QRCODE_STATIC_TYPE.WHATS_APP]: 'whatsapp',
  };

  return mapper[type] || null;
};
